import styled from "styled-components";
import { WrapperContainer, Button } from "../../../components";
import { DropdownOptionsList } from "../../DropdownOptions/styled";
import { colors } from "../../../consts";

export const FilterDropdownOptionsList = styled(DropdownOptionsList)`
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  border: none;

  width: 414px;
  padding: 24px;
  max-height: unset;
  overflow: visible;

  border: 1px solid ${colors.RAISIN_100};
  margin-top: 4px;

  margin-left: -118px;

  ${(props) => props?.isDateRange && "top: -370px !important"}
`;

export const GridRadioGroupWrapper = styled(WrapperContainer)`
  > div {
    display: grid;
    grid-template-columns: auto auto;

    gap: 16px;
  }
`;

export const DateRangeInputWrapper = styled(WrapperContainer)``;

export const ButtonsWrapper = styled(WrapperContainer)`
  ${Button} {
    height: 40px;
    width: fit-content;
    padding: 0 24px;
  }
`;
